export const time = 'Noviembre de 2023'

export const usura = '38,28% E.A.'
